import { render, staticRenderFns } from "./blogtags.vue?vue&type=template&id=0b8c8286&"
import script from "./blogtags.vue?vue&type=script&lang=js&"
export * from "./blogtags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8c8286')) {
      api.createRecord('0b8c8286', component.options)
    } else {
      api.reload('0b8c8286', component.options)
    }
    module.hot.accept("./blogtags.vue?vue&type=template&id=0b8c8286&", function () {
      api.rerender('0b8c8286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yH2NPZG5IzXu/JS/comp/blogtags.vue"
export default component.exports